import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/Production/pending/OwnerDefectReport'

const OwnerDefectReport = () => {
  return (
    <Layout
    title={'Owner’s Defect Report'}
>
<Component />

</Layout>
  )
}

export default OwnerDefectReport